import { createFeature, createReducer, on } from '@ngrx/store';
import { Account } from '@zero/shared/util-models';
import { moneyAccountActions, moneyAccountApiActions } from './money-account.actions';

export interface MoneyAccountState {
  account: Account | null;
  loading: boolean;
  initiallyLoaded: boolean;
}

export const initialMoneyAccountState: MoneyAccountState = {
  account: null,
  loading: false,
  initiallyLoaded: false,
};

export const moneyAccountFeature = createFeature({
  name: 'moneyAccount',
  reducer: createReducer(
    initialMoneyAccountState,
    on(moneyAccountActions.setLoading, (state, { loading }): MoneyAccountState => ({ ...state, loading })),
    on(
      moneyAccountApiActions.loadAccountSuccess,
      (state, { account }): MoneyAccountState => ({
        ...state,
        account,
        initiallyLoaded: true,
        loading: false,
      }),
    ),
    on(
      moneyAccountApiActions.loadAccountFailure,
      (state): MoneyAccountState => ({
        ...state,
        loading: false,
      }),
    ),
  ),
});
